import { forumNetwork } from '../../dashboard/network';

export const getPostsByCats = async (userId, cat) => {
  // Simulate an API call delay
  const { data } = await forumNetwork.getTopic(userId, cat);
  if (data.status && data.status === false) throw Error(data.message);
  return data;
};

export const getPost = async (userId, postId) => {
  // Simulate an API call delay
  return (await forumNetwork.getPost(userId, postId)).data;
};
